angular.module('picmonicng').directive('learnHotspot', [
  '$timeout',
  '$window',
  function ($timeout, $window) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/directives/learn-hotspot.html',
      scope: {
        fact: '=',
        playerService: '=',
      },
      link: function (scope, element, attrs) {
        if (scope.playerService.mode == 'editor') {
          var prevx, prevy;

          var originalValues = {
            x: scope.fact.hotspot_x,
            y: scope.fact.hotspot_y,
          };

          element.bind('mousedown', function (e) {
            prevx = e.pageX;
            prevy = e.pageY;

            originalValues = {
              x: scope.fact.hotspot_x,
              y: scope.fact.hotspot_y,
            };

            angular.element('body').bind('mousemove', moveHandler);
            angular.element('body').bind('mouseup', updateHandler);
          });

          var updateHandler = function () {
            angular.element('body').unbind('mousemove', moveHandler);
            angular.element('body').unbind('mouseup', updateHandler);

            var dataUpdated = false;

            if (scope.fact.hotspot_x != originalValues.x) {
              scope.fact.hotspot_x = originalValues.x;
              dataUpdated = true;
            }
            if (scope.fact.hotspot_y != originalValues.y) {
              scope.fact.hotspot_y = originalValues.y;
              dataUpdated = true;
            }

            if (dataUpdated) {
              scope.playerService.addToHistory();
            }

            scope.$apply();
          };

          var moveHandler = function (e) {
            var ratiox = 2200 / angular.element('.learn-image-wrapper').width();
            var ratioy = 1700 / angular.element('.learn-image-wrapper').height();

            var moved = {
              x: (e.pageX - prevx) * ratiox,
              y: (e.pageY - prevy) * ratioy,
            };

            prevx = e.pageX;
            prevy = e.pageY;

            if (scope.playerService.currentCard && scope.playerService.currentCard.in_workflow) {
              originalValues.x += moved.x;
              originalValues.y += moved.y;
            } else if (scope.fact.characters.length) {
              var boundingCharacter = scope.fact.characters[0];

              if (
                boundingCharacter.character_x + boundingCharacter.crop_x + boundingCharacter.crop_width <
                originalValues.x + moved.x
              ) {
                originalValues.x =
                  boundingCharacter.character_x + boundingCharacter.crop_x + boundingCharacter.crop_width;
              } else if (boundingCharacter.character_x + boundingCharacter.crop_x > originalValues.x + moved.x) {
                originalValues.x = boundingCharacter.character_x + boundingCharacter.crop_x;
              } else {
                originalValues.x += moved.x;
              }

              if (
                boundingCharacter.character_y + boundingCharacter.crop_y + boundingCharacter.crop_height <
                originalValues.y + moved.y
              ) {
                originalValues.y =
                  boundingCharacter.character_y + boundingCharacter.crop_y + boundingCharacter.crop_height;
              } else if (boundingCharacter.character_y + boundingCharacter.crop_y > originalValues.y + moved.y) {
                originalValues.y = boundingCharacter.character_y + boundingCharacter.crop_y;
              } else {
                originalValues.y += moved.y;
              }
            }

            element.css({
              top: 'calc(' + (originalValues.y / 1700) * 100 + '% - 10px)',
              left: 'calc(' + (originalValues.x / 2200) * 100 + '% - 10px)',
            });
          };
        } else {
          element.bind('click', function () {
            scope.$apply(function () {
              if (scope.playerService.locked) return;

              scope.playerService.selectFact(scope.fact);

              if (scope.fact.entity_type_id != 1) {
                if (scope.fact.audio[scope.playerService.audioMode]) {
                  scope.playerService.seek(scope.fact.audio[scope.playerService.audioMode].start);
                } else if (scope.playerService.audioElement) {
                  scope.playerService.audioElement.pause();
                }
              }
            });
          });
        }

        function determinePosition() {
          if (
            scope.fact.selected &&
            window.innerWidth > 468 &&
            !scope.playerService.factsOpen &&
            scope.fact.tooltipStyles
          ) {
            scope.styles = {
              top: scope.fact.tooltipStyles.top,
              left: scope.fact.tooltipStyles.left,
              opacity: 0.3,
            };
          } else {
            scope.styles = {
              top: 'calc(' + (scope.fact.hotspot_y / 1700) * 100 + '% - 10px)',
              left: 'calc(' + (scope.fact.hotspot_x / 2200) * 100 + '% - 10px)',
            };
          }
        }

        scope.$watch(
          function () {
            return scope.fact.selected;
          },
          function (value) {
            if (typeof value != 'undefined') {
              $timeout(determinePosition, 0);
            }
          }
        );

        scope.$watch(attrs.ngBindHtml, function () {
          determinePosition();
        });

        scope.$watch(
          function () {
            return scope.fact.hotspot_x;
          },
          function (value) {
            if (typeof value != 'undefined') {
              $timeout(determinePosition, 0);
            }
          }
        );

        scope.$watch(
          function () {
            return scope.fact.hotspot_y;
          },
          function (value) {
            if (typeof value != 'undefined') {
              $timeout(determinePosition, 0);
            }
          }
        );

        determinePosition();

        angular.element($window).bind('resize', function () {
          scope.$apply(function () {
            determinePosition();
          });
        });
      },
    };
  },
]);
